module.exports = __webpack_public_path__ + "img/capacadastro.840be5be.jpg";